<template>
  <div class="Program-detail-page w-100">
    <b-form @submit="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <template>
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg
                  :src="`/media/svg/icons/Neolex/Basic/${
                    isCreateForm ? 'plus' : 'save'
                  }.svg`"
                />
              </span>
              {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container fluid class="Program-list-page__body mb-6 mt-6">
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">
                    Thông tin chương trình
                  </h5>
                  <b-row>
                    <b-col>
                      <!-- Hàng 1: Mã - Tên chương trình - Thời lượng -->
                      <b-row>
                        <b-col>
                          <basic-input
                            label="Mã"
                            placeholder="Mã"
                            name="code"
                            data-vv-As="Mã"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.code"
                            :state="validateState('code')"
                            :invalidFeedback="errors.first('code')"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Tên chương trình"
                            placeholder="Tên chương trình"
                            name="name"
                            data-vv-As="Tên chương trình"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.name"
                            :state="validateState('name')"
                            :invalidFeedback="errors.first('name')"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Thời lượng"
                            placeholder="Thời lượng"
                            name="totalWeek"
                            data-vv-As="Thời lượng"
                            :required="true"
                            v-validate="'required|min_value:1'"
                            :value.sync="form.totalWeek"
                            :state="validateState('totalWeek')"
                            :invalidFeedback="errors.first('totalWeek')"
                          ></basic-input>
                        </b-col>
                      </b-row>

                      <!-- Hàng 2: Số lượng modules - Mô tả - Level -->
                      <b-row>
                        <b-col>
                          <basic-input
                            label="Số lượng mô đun"
                            placeholder="Số lượng mô đun"
                            name="numberProgramModule"
                            data-vv-As="Số lượng mô đun"
                            :required="true"
                            v-validate="'required|min_value:1'"
                            :value.sync="form.numberProgramModule"
                            :state="validateState('numberProgramModule')"
                            :invalidFeedback="
                              errors.first('numberProgramModule')
                            "
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Mô tả"
                            placeholder="Mô tả"
                            name="description"
                            data-vv-As="Mô tả"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.description"
                            :state="validateState('description')"
                            :invalidFeedback="errors.first('description')"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-select
                            label="Cấp độ"
                            placeholder="Cấp độ"
                            name="maxProgramActivityLevel"
                            data-vv-As="Cấp độ"
                            :required="true"
                            v-validate="'required'"
                            :options="levels"
                            track-by="value"
                            value-label="text"
                            :value.sync="form.maxProgramActivityLevel"
                            :state="validateState('maxProgramActivityLevel')"
                            :invalidFeedback="
                              errors.first('maxProgramActivityLevel')
                            "
                            @input="
                              selected(
                                $event,
                                'maxProgramActivityLevel',
                                levels,
                              )
                            "
                          ></basic-select>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="card-footer d-flex align-items-lg-center justify-content-center"
                >
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="resetData"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset dữ liệu
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        :src="`/media/svg/icons/Neolex/Basic/${
                          isCreateForm ? 'plus' : 'save'
                        }.svg`"
                      />
                    </span>
                    {{ isCreateForm ? 'Tạo mới' : 'Cập nhật' }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      levels: [
        {
          text: 'Level 0',
          value: 0,
        },
        {
          text: 'Level 1',
          value: 1,
        },
        {
          text: 'Level 2',
          value: 2,
        },
        {
          text: 'Level 3',
          value: 3,
        },
        {
          text: 'Level 4',
          value: 4,
        },
      ],
      form: {},
      file: null,
      preview: null,
      loading: false,
    };
  },
  created() {
    this.initDataInSelect();
    this.loadProgramData();
  },
  computed: {
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
  },
  methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] =
        optionsArr.find((el) => el.value === value) || null;
      const selectedValue = this.form[formProperty];

      if (selectedValue || selectedValue?.value === 0) {
        this.$validator.reset({ name: formProperty });
        this.$validator.errors.remove(formProperty);
      }

      this.$nextTick(() => {
        this.$validator.validate(formProperty);
      });
    },
    resetData() {
      this.form.code = null;
      this.form.name = null;
      this.form.totalWeek = null;
      this.form.numberProgramModule = null;
      this.form.description = null;
      this.form.maxProgramActivityLevel = null;
      this.form.status = null;
      this.$validator.reset();
      this.$validator.errors.clear();
    },
    handleChangeSelect(value, formProperty) {
      console.log('isShowError', this.isShowError);
      var newOptions = value ? value[0] : null;
      console.log(newOptions);
      switch (formProperty) {
        default:
          break;
      }
    },

    async initDataInSelect() {
      try {
        this.loading = true;
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately, e.g., show error message
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'program_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      } else {
        this.submit();
      }
    },
    async submit() {
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;
      this.form.code && payload.append('code', this.form.code);
      this.form.name && payload.append('name', this.form.name);
      this.form.totalWeek && payload.append('totalWeek', this.form.totalWeek);
      this.form.numberProgramModule &&
        payload.append('numberProgramModule', this.form.numberProgramModule);
      this.form.description &&
        payload.append('description', this.form.description);
      this.form.maxProgramActivityLevel &&
        payload.append(
          'maxProgramActivityLevel',
          typeof this.form.maxProgramActivityLevel === 'object'
            ? this.form.maxProgramActivityLevel.value
            : this.form.maxProgramActivityLevel,
        );
      this.form.status && payload.append('status', this.form.status);

      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo chương trình mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin chương trình này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`Program`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Chương trình mới đã được tạo!',
        });
        this.$router.push({ name: 'program_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Tên chương trình bị trùng',
        });
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`Program/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Chương trình đã được cập nhật!',
        });
        this.$router.push({ name: 'program_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Tên chương trình bị trùng',
        });
      } finally {
        this.loading = false;
      }
    },

    async loadProgramData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`Program/${id}`);
        this.form = data;
        this.form.maxProgramActivityLevel = this.levels.find(
          (item) => item.value == data.maxProgramActivityLevel,
        );
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
